export enum DeliveryNoteCustomFieldType {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  OPTIONS = 'OPTIONS',
}

export interface DeliveryNoteCustomFieldOption {
  name: string
}

export interface DeliveryNoteCustomField {
  id?: string
  name: string
  type: DeliveryNoteCustomFieldType
  options?: DeliveryNoteCustomFieldOption[]
  required?: boolean
  hideInPdf?: boolean
  value?: string
}

export interface DeliveryNoteCustomFieldRq {
  id: string
  value?: string
}

export interface DeliveryNoteConfig {
  companyId: string
  customFields: DeliveryNoteCustomField[]
}

export const createEmptyDeliveryNoteConfig = (): DeliveryNoteConfig => ({
  companyId: '',
  customFields: [],
})

export const createCustomFieldDefinition = (): DeliveryNoteCustomField => ({
  id: crypto.randomUUID(),
  name: '',
  type: DeliveryNoteCustomFieldType.STRING,
  options: [],
  required: false,
  hideInPdf: false,
})

export const createCustomFieldOption = (): DeliveryNoteCustomFieldOption => ({
  name: '',
})
